const { regClass, property } = Laya;
import GameControl from "./GameLevel"
import { PhysicsGameMainRTBase } from "./PhysicsGameMainRT.generated";


@regClass('Y5UkAabiTgWFZQnBL1EpEw')

export default class PhysicsGameMainRT extends PhysicsGameMainRTBase {
    /**设置单例的引用方式，方便其他类引用 */
    static instance: PhysicsGameMainRT;
    /**当前游戏积分字段 */
    private _score: number;
    /**游戏控制脚本引用，避免每次获取组件带来不必要的性能开销 */
    private _control: GameControl;

    constructor() {
        super();
        PhysicsGameMainRT.instance = this;
        // Laya.MouseManager.multiTouchEnabled = false;
    }


    onEnable(): void {
        this._control = this.getComponent(GameControl);
        //this.tipLbll.on(Laya.Event.CLICK, this, this.onTipClick);
    }

    // onTipClick(e: Laya.Event): void {
    //     //this.tipLbll.visible = false;
    //     this._score = 0;
    //     //this.scoreLbl.text = "分数：";
    //     this._control.startGame();
    // }

    /**增加分数 */
    addScore(value: number = 1): void {
        this._score += value;
        //this.scoreLbl.text = "分数：" + this._score;
    }

    /**停止游戏 */
    stopGame(): void {
        // this.tipLbll.visible = true;
        // this.tipLbll.text = "游戏结束了，点击屏幕重新开始";
        this._control.stopGame();
    }
}